import React from 'react';

export const MinusIcon = ({ nameOfClass }) => (
    <svg className={nameOfClass} viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.5 6.21428H6.71429L5.28571 6.21428L1.5 6.21428V5.78571H5.28571L6.71429 5.78571L10.5 5.78571V6.21428Z" />
    </svg>
);
